import _ from 'lodash';
    

    var instance = null;

    function SystemTypes() {
        if (instance !== null) {
            throw new Error('Cannot instantiate more than one SystemTypes.');
        }

        //  bridge == vmr
        this.BRIDGE_TYPE_ID = 'vmr';
        this.CALL_CONTROL_TYPE_ID = 'call';

        // raw bridge types
        this.REALTIME_BRIDGE_TYPES = ['ACANO', 'CMS', 'BJN', 'CTPS', 'MCU', 'PEXIP', 'RMX', 'SKYPE', 'ZOOM'];

        // raw call control types
        this.REALTIME_CALL_CONTROL_TYPES = ['CUCM', 'DMA', 'SKYPE', 'VCS','VCSX', 'RPAD'];
        // extended call control types (VCS becomes VCS Control, VCSX becomes VCS Expressway)
        this.REALTIME_CALL_CONTROL_TYPES_EXTENDED = ['CUCM', 'DMA', 'SKYPE', 'VCS Control', 'VCS Expressway'];

        this.REALTIME_BRIDGE_TYPES_STR = this.REALTIME_BRIDGE_TYPES.toString();
        this.REALTIME_CALL_CONTROL_TYPES_STR = this.REALTIME_CALL_CONTROL_TYPES.toString();
        this.REALTIME_SYSTEM_TYPES_STR = this.REALTIME_BRIDGE_TYPES_STR + ',' + this.REALTIME_CALL_CONTROL_TYPES_STR + ',' + 'RPRM' /*RPRM is neither CallControl nor Bridge*/;
    }

    SystemTypes.prototype = {
        isCallControl: function (type) {
            return _.includes(this.REALTIME_CALL_CONTROL_TYPES, type);
        },
        isBridge: function (type) {
            return _.includes(this.REALTIME_BRIDGE_TYPES, type);
        },
        getRealtimeSystemTypesString: function () {
            return this.REALTIME_SYSTEM_TYPES_STR;
        },
        getBridgeTypeIdentifier: function () {
            return this.BRIDGE_TYPE_ID;
        },
        getRealtimeBridgeTypes: function() {
            return _.extend({}, this.REALTIME_BRIDGE_TYPES);
        },
        getRealtimeBridgeTypesString: function () {
            return this.REALTIME_BRIDGE_TYPES_STR;
        },
        getCallControlTypeIdentifier: function () {
            return this.CALL_CONTROL_TYPE_ID;
        },
        getRealtimeCallControlTypes: function() {
            return _.extend({}, this.REALTIME_CALL_CONTROL_TYPES);
        },
        getRealtimeCallControlTypesExtended: function() {
            return _.extend({}, this.REALTIME_CALL_CONTROL_TYPES_EXTENDED);
        },
        getRealtimeCallControlTypesStringList: function () {
            return this.REALTIME_CALL_CONTROL_TYPES_STR;
        },
        getDisplayForCategory: function (category) {
            var displayText;

            //  TODO: should 'Skype' case added here?
            switch (category) {
                case 'ACANO':
                case 'CMS':
                    displayText = 'Spaces';
                    break;

                case 'BJN':
                    displayText = 'Total Meetings';
                    break;

                case 'CTPS - Conductor Managed':
                case 'CUCM':
                case 'DMA':
                    displayText = 'Calls';
                    break;

                case 'PEXIP':
                    displayText = 'Call Licenses Used';
                    break;

                case 'VCS':
                case 'VCS Control':
                case 'VCS Expressway':
                case 'VCSX':
                    displayText = 'Non Traversal Calls';
                    break;

                case 'ZOOM':
                    displayText = 'CRC Port';
                    break;

                default:
                    displayText = 'Video Port';
            }
            return displayText;
        },
        getDisplayOptionByCategory: function (category) {
            var displayOptions;

            //  TODO: should 'Skype' case added here?
            switch (category) {
                case 'ACANO':
                case 'CMS':
                    displayOptions = ['Spaces', 'Participants'];
                    break;

                case 'BJN':
                    displayOptions = ['Total Meetings', 'Total Participants'];
                    break;

                case 'CUCM':
                    displayOptions = ['Calls'];
                    break;

                case 'CTPS - Conductor Managed':
                    displayOptions = ['Calls', 'Screens'];
                    break;

                case 'DMA':
                    displayOptions = ['Calls'];
                    break;

                case 'PEXIP':
                    displayOptions = ['Call Licenses Used'];
                    break;

                case 'RMX':
                    displayOptions = ['Video Port', 'Audio Port'];
                    break;

                case 'VCS':
                case 'VCS Control':
                case 'VCS Expressway':
                case 'VCSX':
                    displayOptions = ['Traversal Calls', 'Non Traversal Calls'];
                    break;

                case 'ZOOM':
                    displayOptions = ['CRC Port'];
                    break;

                default:
                    displayOptions = ['Video Port', 'Audio Port'];
                    break;
            }
            return displayOptions;
        }
    };

    SystemTypes.getInstance = function () {
        if (instance === null) {
            instance = new SystemTypes();
        }
        return instance;
    };

    export default SystemTypes.getInstance();


